import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";

export class SelectControl extends BaseControl {
    private isNumber: boolean;

    constructor(protected input: HTMLSelectElement, controller: Controller, field: string, private validationMessage?: string) {
        super(controller, field);

        this.isNumber = input.getAttribute("data-number") == "true";

        if (controller.automaticUpdateModel) {
            // save new value on change
            input.addEventListener("change", this.onChange);
        }
    }

    public clearOptions() {
        while (this.input.options.length > 0) {
            this.input.options.remove(0);
        }
    }

    public addOption(text: string, value: string) {
        const option = document.createElement("option");
        option.value = value;
        option.innerText = text;
        this.input.options.add(option);
    }

    onChange = (ev: Event) => {
        this.saveValue(this.input.value);
    }


    dispose() {
        this.input.removeEventListener("change", this.onChange);
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        if (this.isNumber) {
            this.input.value = value.toString();
        }
        else {
            this.input.value = (value != null && value != undefined) ? value : "";
        }
    }

    updateModelFromControl() {
        if (this.isNumber) {
            let value = parseInt(this.input.value);
            if (isNaN(value)) {
                value = 0;
            }
            this.setModelValue(value);
        }
        else {
            this.setModelValue(this.input.value);
        }
    }

    validate() {
        if (this.validationMessage) {
            // Check if an option is selected
            if (this.input.selectedIndex == null || this.input.selectedIndex == undefined || this.input.selectedIndex == -1) {
                throw this.validationMessage;
            }
        }
    }

    focus() {
        this.input.focus();
    }
}
